
export const initialValuesFormNumeroSerie = {
    rut: '',
    numeroserie: '',
    numeroserieCompare: '',
    mandatario: false,
    beneficiario: false,
    ejecutivoAfp:false,
    token:''
}